import { ArrowLeft, ShieldCheck } from 'lucide-react';
import { Link, Outlet } from 'react-router-dom';
import { Logo } from './Logo';
import { ThemeToggle } from './ThemeToggle';

export function RepresentativeShell(){return <div className="owner-shell"><header className="owner-shell-header"><Link to="/" aria-label="HostelGrid home"><Logo/></Link><div><span><ShieldCheck size={15}/> Private verification workspace</span><ThemeToggle/><Link className="owner-back-link" to="/"><ArrowLeft size={15}/>Marketplace</Link></div></header><main><Outlet/></main></div>}
